import * as angular from 'angular';

import {
  DatasourceEntitlementResource,
  DatasourceResource,
  DeprecatedApiService,
  GroupResource,
  OrganizationResource,
} from '@mode/legacy/data-access-model-js';
import { ApiTypes } from '@mode/shared/contract-common';
import { ToastService } from '@mode/shared/util-toast';
import { EntitledActionState } from '~/modules/org-settings/components/connection/connection-permissions/connection-permissions-access-dropdown/connection-permissions-access-dropdown.component';

export class ConnectionPermissionsService {
  static $inject = ['ToastService', 'ApiService'];

  constructor(private alertService: ToastService, private apiService: DeprecatedApiService) {}

  getEveryoneGroup(organization: OrganizationResource): angular.IPromise<GroupResource> {
    return this.apiService.getResource<GroupResource>(organization, 'everyone_group');
  }

  getDefaultEntitlement(
    datasource: DatasourceResource,
    everyoneGroup: GroupResource
  ): angular.IPromise<DatasourceEntitlementResource> {
    const isDefaultEntitlement = (entitlement) => entitlement.accessor_token === everyoneGroup.token;
    const getOptions = { relationAs: 'data_source_entitlements' };

    return this.apiService
      .getResources<DatasourceEntitlementResource>(datasource, 'permissions', getOptions)
      .then((entitlements) => entitlements.find(isDefaultEntitlement));
  }

  getEntitlementAccessOptions(entitlement: ApiTypes.ModeResource): EntitledActionState[] {
    let options = [];

    if (!entitlement) return options;

    if (entitlement.hasForm('edit')) {
      options = entitlement.forms('edit')._inputs.permission.action.options.slice();
    }

    if (entitlement.hasForm('destroy')) {
      options = [...options, EntitledActionState.None];
    }

    return options;
  }

  public alertAccessRemoved(options: { redirect?: boolean } = {}) {
    let msg = 'Access removed';

    if (options.redirect) {
      msg = `${msg}. Redirecting...`;
    }

    this.alertService.success(msg);
  }

  public alertAccessGranted() {
    this.alertService.success('Access granted');
  }

  public alertAccessUpdated() {
    this.alertService.success('Access updated');
  }
}
